/**
 * Предмети НМТ і колоди, визначені з матеріалу.
 *
 * Дзеркалить functions/_shared/subjects.js і functions/_shared/decks.js: Gemini
 * сам визначає предмет і тему, а ми показуємо їх у PreviewModal і заздалегідь
 * кажемо, у яку колоду картки потраплять — щоб користувач бачив результат до
 * натискання «Зберегти». Рішення про колоду все одно ухвалює сервер.
 */

import { SUBJECTS } from './constants.js'

/** Опції для вибору предмета: три предмети НМТ + «змішане» для рідкісних випадків. */
export const NMT_SUBJECT_OPTIONS = [
  ...SUBJECTS.filter((s) => s.id !== 'змішане').map((s) => ({ value: s.id, label: s.label })),
  { value: 'змішане', label: 'Змішане / інше' },
]

export const subjectLabel = (id) =>
  SUBJECTS.find((s) => s.id === id)?.label ?? SUBJECTS[0].label

/** «Математика — Тригонометрія» / «Історія України» (коли теми немає). */
export function deckTitleFor(subjectId, topic = null) {
  const label = subjectLabel(subjectId)
  const cleanTopic = String(topic ?? '').trim().replace(/\s+/g, ' ')
  return cleanTopic ? `${label} — ${cleanTopic}` : label
}

/** Ключ пошуку колоди: регістр, пробіли навколо дефіса й тире — одне й саме. */
export function deckKey(title) {
  return String(title ?? '')
    .toLowerCase()
    .replace(/["'«»“”]/g, '')
    .replace(/[–—−-]/g, '-')
    .replace(/\s*-\s*/g, '-')
    .replace(/\s+/g, ' ')
    .trim()
}

/**
 * Яку колоду використати для пари subject + topic: «Предмет — Тема», потім
 * колода, названа лише темою. Коли теми немає — колода самого предмета.
 * Якщо тема названа, але колоди для неї немає — null: створюємо нову.
 */
export function findDeckFor(decks, subjectId, topic = null) {
  if (!Array.isArray(decks) || !decks.length) return null

  const inSubject = decks.filter((d) => String(d.subject ?? '') === String(subjectId ?? ''))
  if (!inSubject.length) return null

  const cleanTopic = String(topic ?? '').trim()
  if (!cleanTopic) {
    return inSubject.find((d) => deckKey(d.title) === deckKey(subjectLabel(subjectId))) ?? null
  }

  const full = deckKey(deckTitleFor(subjectId, cleanTopic))
  const topicOnly = deckKey(cleanTopic)

  return (
    inSubject.find((d) => deckKey(d.title) === full) ??
    inSubject.find((d) => deckKey(d.title) === topicOnly) ??
    null
  )
}
